import { useQuery } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";

import { mainApi } from "../../../../services/httpClients";

export const useGetUserHistory = (
  onSuccess?: (data: AxiosResponse<any, any>) => void,
  onError?: (error: AxiosError<any, any>) => void
) =>
  useQuery<AxiosResponse<any, any>, AxiosError<any, any>>(
    ["getUserHistory"],
    () => mainApi.get("/userHistory"),
    {
      onSuccess,
      onError,
    }
  );
